var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import styles from "./icon-button.module.css";
export var IconButton = forwardRef(function IconButton(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.type, type = _c === void 0 ? "button" : _c, icon = _a.icon, _d = _a.size, size = _d === void 0 ? "md" : _d, _e = _a.theme, theme = _e === void 0 ? "primary" : _e, _f = _a.raised, raised = _f === void 0 ? false : _f, _g = _a.centered, centered = _g === void 0 ? false : _g, rest = __rest(_a, ["className", "type", "icon", "size", "theme", "raised", "centered"]);
    return (_jsx("button", __assign({}, rest, { type: type, className: classNames(styles["container"], className, [styles["theme-".concat(theme)]], (_b = {},
            _b[styles[size]] = true,
            _b[styles["raised"]] = raised,
            _b[styles["centered"]] = centered,
            _b)), ref: ref, children: icon })));
});
